import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #960d0de5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 90px;
  z-index: 1000;
  position: fixed;
  width: 100%;
  gap: 100px;
  top: 0;
  left: 0;
  padding: 1% 10% 0% 10%;
  box-sizing: border-box;

  @media (max-width: 1080px) {
    padding: 1% 5% 0% 5%;
  }

  @media (max-width: 600px) {
    padding: 1% 2% 1% 2%;
  }

  @media (max-width: 1080px) {
    gap: 50px;
  }

  @media (max-width: 700px) {
    height: 50px;
    justify-content: space-between;
    gap: 0;
  }
`;

export const Logo = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  height: 120px;
  margin-top: 50px;
  cursor: pointer;

  @media (max-width: 1080px) {
    height: 100px;
  }

  @media (max-width: 700px) {
    height: 75px;
    margin-top: 35px;
  }
`;

export const Menu = styled.div`
  display: flex;
  height: 100%;
  width: auto;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 700px) {
    display: none;
    padding-right: 20px;
  }
`;

export const MenuMobile = styled.div`
  display: none;
  height: 100%;
  width: auto;
  align-items: center;
  justify-content: center;
  gap: 20px;
  cursor: pointer;

  @media (max-width: 700px) {
    display: flex;
  }
`;

export const MenuMobileFalse = styled.div`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    color: #960d0d00;
    height: 40px;
    width: 50px;
    align-items: center;
    justify-content: center;
    gap: 20px;
  }
`;

export const MenuItem = styled.div`
  margin: 0 20px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    margin: 0 10px;
  }
`;

export const MenuButton = styled.button`
  background-color: transparent;
  border: none;
  color: #fff;
  padding: 20px;
  height: 100%;
  font-size: 18px;
  font-family: "Passion One", cursive;
  cursor: pointer;

  &.active {
    border-bottom: 4px solid #fff;
    pointer-events: none;
  }

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 1080px) {
    font-size: 16px;
    padding: 10px;
  }

  @media (max-width: 700px) {
    height: 50px;
    font-size: 14px;
  }
`;

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #0000009e;
  z-index: 999;
  display: flex;
  justify-content: flex-end;
`;

export const DrawerContent = styled.div`
  display: flex;
  width: 250px;
  flex-direction: column;
  height: 100%;
  gap: 10px;
  padding: 20px;
  background: #960d0d;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  animation: slideIn 0.3s ease-out forwards;

  @keyframes slideIn {
    to {
      transform: translateX(0%);
    }
  }
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #fff;
  font-size: 50px;
  padding: 0;
  margin: 0;
  float: right;
  cursor: pointer;
  text-align: right;
`;

export const DivMenu = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  margin: 0px;
  font-weight: 600;
  line-height: 108%;
  letter-spacing: 0;
  font-family: "Montserrat", sans-serif;
  horizontal-align: center;
  vertical-align: middle;
`;
